/* Brands Only — automatische kadrering van packshots in productkaarten.
     Laadt een miniatuur (48 px), zoekt het kledingstuk t.o.v. de effen achtergrond en
     schaalt/verschuift de kaartfoto zodat elk stuk ± dezelfde hoogte krijgt.
     Modelfoto's, foto's zonder effen achtergrond en foto's die al vol staan, blijven ongemoeid. */
  (function () {
    if (!('HTMLCanvasElement' in window)) return;
    var TARGET_H = 0.80, TARGET_W = 0.88, MIN_S = 0.85, MAX_S = 2.0, FRAME = 4 / 3;
    var cache = {};
    try { cache = JSON.parse(sessionStorage.getItem('bo-fit') || '{}'); } catch (e) { cache = {}; }
    var dirty = false;
    function save() { if (!dirty) return; dirty = false; try { sessionStorage.setItem('bo-fit', JSON.stringify(cache)); } catch (e) {} }

    function analyse(img) {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return null;
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0);
      var d;
      try { d = ctx.getImageData(0, 0, w, h).data; } catch (e) { return null; }
      var m = Math.max(1, Math.round(Math.min(w, h) * 0.05));
      var rs = [], gs = [], bs = [];
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
        if (y < m || y >= h - m || x < m || x >= w - m) { var i = (y * w + x) * 4; rs.push(d[i]); gs.push(d[i + 1]); bs.push(d[i + 2]); }
      }
      rs.sort(function (a, b) { return a - b; }); gs.sort(function (a, b) { return a - b; }); bs.sort(function (a, b) { return a - b; });
      var br = rs[rs.length >> 1], bg = gs[gs.length >> 1], bb = bs[bs.length >> 1];
      if ((br + bg + bb) / 3 < 180) return null;               // donkere achtergrond: geen packshot
      var total = 0, unif = 0, x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
        var j = (yy * w + xx) * 4;
        var diff = Math.abs(d[j] - br) + Math.abs(d[j + 1] - bg) + Math.abs(d[j + 2] - bb);
        var border = (yy < m || yy >= h - m || xx < m || xx >= w - m);
        if (border) { total++; if (diff < 45) unif++; }
        if (diff > 60) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
      }
      if (!total || unif / total < 0.85) return null;           // geen effen rand: geen packshot
      if (x1 < 0) return null;
      var gh = (y1 - y0 + 1) / h, gw = (x1 - x0 + 1) / w;
      if (gh > 0.9 || gh < 0.15) return null;                    // staat al vol, of is te klein om iets van te maken
      return { cx: (x0 + x1 + 1) / 2 / w, cy: (y0 + y1 + 1) / 2 / h, gh: gh, gw: gw, ar: w / h };
    }

    function apply(media, a) {
      var img = media.querySelector('.bo-pc__img:not(.bo-pc__img--alt)');
      if (!img) return;
      if (!a) { img.classList.add('is-nofit'); return; }
      // gerenderde grootte in kader-eenheden (breedte 1, hoogte 4/3) alsof object-fit: cover
      var RW, RH;
      if (a.ar >= 1 / FRAME) { RH = FRAME; RW = FRAME * a.ar; } else { RW = 1; RH = 1 / a.ar; }
      var s = Math.min(TARGET_H * FRAME / (a.gh * RH), TARGET_W / (a.gw * RW));
      s = Math.max(MIN_S, Math.min(MAX_S, s));
      var W = RW * s, H = RH * s;
      var left = 0.5 - a.cx * W, top = FRAME / 2 - a.cy * H;
      img.style.width = (W * 100).toFixed(2) + '%';
      img.style.height = (H / FRAME * 100).toFixed(2) + '%';
      img.style.left = (left * 100).toFixed(2) + '%';
      img.style.top = (top / FRAME * 100).toFixed(2) + '%';
      img.classList.add('is-fitted');
    }

    function fit(media) {
      if (media.dataset.boFitDone) return;
      media.dataset.boFitDone = '1';
      var src = media.dataset.boFit;
      if (!src) { apply(media, null); return; }
      if (cache[src] !== undefined) { apply(media, cache[src]); return; }
      var t = new Image();
      t.crossOrigin = 'anonymous';
      t.onload = function () { var a = null; try { a = analyse(t); } catch (e) { a = null; } cache[src] = a; dirty = true; apply(media, a); save(); };
      t.onerror = function () { apply(media, null); };
      t.src = src;
    }

    function run(scope) {
      var list = (scope || document).querySelectorAll('.bo-pc__media[data-bo-fit]');
      for (var i = 0; i < list.length; i++) fit(list[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
    else run();
    // kaarten die later in de pagina komen (filters, laad meer, aanbevelingen)
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1) { if (n.matches && n.matches('.bo-pc__media[data-bo-fit]')) fit(n); else if (n.querySelectorAll) run(n); }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
